import axios from "axios";
import QS from "qs";
import moment from "moment-timezone";
import xlooLib from "../../../librarys/xlooLib";

export default {
    SET_checkDonorInformation: async (context, payload) => {
        let urlDonorPortal;
        if (location.hostname === 'localhost') {
            urlDonorPortal = "http://localhost:8080/donorportal/";
        } else {
            urlDonorPortal = location.origin + location.pathname;
        }
        const urlRequest = urlDonorPortal + 'api?action=checkDonorInformation';
        try {
            await axios.post(urlRequest, QS.stringify(payload));
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    SET_getDonorInformation: async (context, payload) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'

        const dataRequest = {
            action: 'apiPointPortal',
            apiPointAction: 'TemporaryLinkInformation',
            id: payload.idDonor,
            appt: payload.appt,
        }
        const res_getDonorInformation = await xlooLib.ajaxCheckSession(urlRequest, dataRequest)
        const data = res_getDonorInformation?.data?.result?.data

        if(typeof data.first_name !=='undefined'){
            context.commit('set_firstName', data.first_name)
        }
        if(typeof data.last_name !=='undefined'){
            context.commit('set_lastName', data.last_name)
        }
        if(typeof data.sms_opted_out !=='undefined'){
            context.commit('set_smsOptedOut', data.sms_opted_out)
        }
        if(typeof data.phone_mobile !=='undefined'){
            context.commit('set_phoneMobile', data.phone_mobile)
        }
    },
    SET_donorFutureDonate: async (context) => {
        if (context.getters.idDonor == '' || context.getters.idDonor == null || typeof context.getters.idDonor === 'undefined'){
            return
        }
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        const dataRequest = {
            action: 'getRelationships',
            module_name: 'Donor_Donor',
            module_id: context.getters.idDonor,
            relationship_name: 'Appointments',
            where_condition: "date_start > TIMEZONE('utc', NOW()) AND (status = 'Scheduled' OR status = 'Walk-in') AND deleted <> '1'", // PostgreSQL
            related_fields: ['id', 'date_start', 'location', 'procedure_type_c', 'status', 'approx_time', ],
            related_module_link_name_to_fields_array: [],
        }
        const res_donorFutureDonate = await xlooLib.ajaxCheckSession(urlRequest, dataRequest)
        const result = res_donorFutureDonate.data.result.entry_list
        let arrFutureDonations = [];if (result.length > 0) {
            let dateStart = null
            const timeZone = context.rootGetters["settingsAndCustomize/donorPortalSettings"].timeZone
            for (let i = 0; i < result.length; ++i) {
                dateStart = moment.utc(result[i].name_value_list.date_start.value, 'YYYY-MM-DD HH:mm:ss')
                arrFutureDonations.push({
                    dateStart: dateStart,
                    dateStartDay: dateStart.tz(timeZone).format('YYYY/MM/DD'),
                    dateStartTime: dateStart.tz(timeZone).format("hh:mm A"),
                    idDonation: result[i].name_value_list.id.value,
                    locationDonation: result[i].name_value_list.location.value,
                    procedureType: result[i].name_value_list.procedure_type_c.value,
                    status: result[i].name_value_list.status.value,
                    approxTime: result[i].name_value_list?.approx_time?.value,
                })
            }
        }
        context.commit('set_futureDonates', arrFutureDonations);

        return arrFutureDonations
    },
    SET_donorPreviousDonate: async (context, payload) => {
        const totalSum = payload.totalSum.data.result.data
        let prevDon = payload.previousDonate.data
        console.log('prevDon = ', prevDon)
        let selectFields = []
        let eligibilityCode
        const layoutTests = prevDon.layout.Donor_DonationTests
        const softdonorCodes = context.rootGetters["settingsAndCustomize/crmSettings"].softdonorCodes

        context.commit('settingsAndCustomize/set_previousDonation', {arrCreateTab: prevDon.layout.Donor_Donations}, {root: true})

        for (let i in prevDon.layout.Donor_Donations) {
            selectFields.push(prevDon.layout.Donor_Donations[i].name)
        }
        try {
            let entryList = prevDon.data
            if (entryList.length > 0) {
                let arrDonorsDonations = []
                for (let i in entryList) {
                    let row = {}
                    let entry = entryList[i].data

                    for (let j in selectFields) {
                        let name = selectFields[j]
                        let value = entry[name].value
                        if (name === 'donations_procedure') {
                            eligibilityCode = Object.keys(softdonorCodes[value])[0]
                            value = softdonorCodes[value][eligibilityCode]
                        }
                        row[name] = value
                    }
                    if (typeof entryList[i].donationTests !== 'undefined' && entryList[i].donationTests.length > 0) {
                        entryList[i].donationTests.forEach(el => {
                            Object.keys(el).forEach(indexEl => {
                                el[indexEl].label = layoutTests[indexEl]?.label
                            })
                        })
                        row['donationTests'] = entryList[i].donationTests
                        row['donationTestsExists'] = true
                    }
                    arrDonorsDonations.push(row)
                }
                context.commit('set_previousDonations', arrDonorsDonations)
            }
            return await context.dispatch('SET_donorPreviousDonate_getLifetimeDonations', {
                lifetimeDonations: totalSum,
                fields: prevDon.layout.Donor_Donor,
            });
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }

    },
    SET_donorGetCharacteristics: async (context) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        const dataRequest = {
            action: 'getCharacteristics',
        }
        try {
            const res_getCharacteristics = await axios.post(urlRequest, QS.stringify(dataRequest));
            const result = res_getCharacteristics.data.result
            context.commit('set_donorCharacteristics', result)

        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    SET_donorEligibility: async (context) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        const dataRequest = {
            action: 'getEligibility',

        }
        try {
            const res_donorEligibility = await axios.post(urlRequest, QS.stringify(dataRequest));
            if (typeof res_donorEligibility.data.result.entry_list[0] === 'undefined') return

            const result = res_donorEligibility.data.result.entry_list
            let nameValueList,
                eligibilities,
                order,
                nameProcedure,
                codeProcedure,
                eligibilityData = []

            Object.keys(result).forEach(index => {
                nameValueList = result[index].name_value_list

                eligibilities = context.rootGetters["settingsAndCustomize/crmSettings"].eligibilities
                order = context.rootGetters["settingsAndCustomize/crmSettings"].order

                Object.keys(eligibilities).forEach(indexEl => {
                    if(eligibilities[indexEl] === nameValueList.eligibility_procedure.value){
                        nameProcedure = order[indexEl]
                        codeProcedure = indexEl
                        eligibilityData.push({
                            eligibilityDate: nameValueList.eligibility_date.value,
                            eligibilityStatus: nameValueList.eligibility_status.value,
                            eligibilityProcedureClass: nameValueList.eligibility_procedure_class.value,
                            eligibilityProcedureType: nameValueList.eligibility_procedure_type.value,
                            eligibilityNameProcedure: nameProcedure,
                            eligibilityCodeProcedure: codeProcedure,
                        })
                    }
                })
            });
            context.commit('set_donorEligibility', eligibilityData)

        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },

    SET_determinationOfCoordinates: async (context, payload) => {
        let coordinates = {lat: payload.lat, lng: payload.lng}
        let zip = payload.zip

        if (coordinates.lat !== '' && coordinates.lng !== '') {
            return coordinates

        } else if (zip !== ''/* && !context.getters.determinationCoordinates.zipCodeDeterminationOfCoordinates*/) {
            coordinates = await determinationOfCoordinatesByZip(zip)
        }
        if (coordinates.lat === '' && coordinates.lng === '') {
            coordinates = await determinationOfCoordinatesZipAfterGeo();
        }
        return coordinates

        async function determinationOfCoordinatesZipAfterGeo() {
            let coordinates = await determinationOfCoordinatesByGeoLocation();
            if (typeof coordinates === 'undefined'){
                let checkZip = window.prompt('Your location is not defined. Enter your postal code', '');
                if (!(typeof checkZip === 'undefined' || checkZip === null || checkZip === '')) {
                    coordinates = await determinationOfCoordinatesByZip(checkZip);
                } else {
                    return {lat: '', lng: ''}
                }
            }
            return coordinates
        }

        async function determinationOfCoordinatesByZip(zip) {
            let position = await getCoordinates(zip);
            return position

            function getCoordinates(zip) {
                context.getters.determinationCoordinates.zipCodeDeterminationOfCoordinates = true;
                const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
                const dataRequest = {
                    action: 'entryPoints',
                    entryAction: 'bookingGeo',
                    zip: zip,
                }
                return axios.post(urlRequest, QS.stringify(dataRequest))
                    .then(response => {
                        try {
                            if (typeof response.data !== 'undefined') {
                                if (typeof response.data.result.coord !== 'undefined') {
                                    return {lat: response.data.result.coord.lat, lng: response.data.result.coord.lng}
                                }
                            }
                            return {lat: '', lng: ''}
                        } catch (e) {
                            console.log('error zip coordinate', e);
                        }
                    })
                    .catch(error => console.log(error));
            }
        }

        async function determinationOfCoordinatesByGeoLocation() {
            if (navigator.geolocation) {
                try {
                    const position = await getCoordinates();
                    if (typeof position.coords.latitude !== 'undefined' && typeof position.coords.longitude !== 'undefined') {
                        return {lat: position.coords.latitude, lng: position.coords.longitude}
                    }
                    return {lat: '', lng: ''}
                } catch (err) {
                    console.log('Error geolocation', err)
                }
                // eslint-disable-next-line no-inner-declarations
                function getCoordinates() {
                    return new Promise(function (resolve, reject) {
                        navigator.geolocation.getCurrentPosition(resolve, reject, {
                            timeout: 30000,
                            enableHighAccuracy: true,
                            maximumAge: 75000
                        });
                    });
                }
            }
        }
    },
    SET_donorPreviousDonate_getLifetimeDonations: async (context, params) => {
        let lifetimeDonations = params.lifetimeDonations
        let fields = params.fields
        let sumProcedure = []
        let keyLT

        Object.values(fields).forEach(function(element) {
            keyLT = Object.keys(lifetimeDonations).find(key => lifetimeDonations[key].name === element.name)
            sumProcedure.push({nameProcedure: element.label, sum: lifetimeDonations[keyLT].sum, key: element.name})
        })

        return sumProcedure
    },
}
